import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Storniert: {{reason}}',
    fulfilled: 'Dies ist eine alte Bestellung',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Nicht angenommen',
    [OrderRejectionReason.ClosingSoon]: 'Bald geschlossen',
    [OrderRejectionReason.ItemUnavailable]: 'Artikel nicht mehr verfügbar',
    [OrderRejectionReason.OrderTooBig]: 'Bestellung zu groß',
    [OrderRejectionReason.CustomerMistake]: 'Kundenfehler',
    [OrderRejectionReason.Other]: 'Andere',
    fully_refunded: 'Bestellung wurde vollständig zurückerstattet',
  },
};
